import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from '../message.service';
import { MsalService } from '@azure/msal-angular';
import { ConfirmDialogDeleteService } from '../Services/confirm-dialog-delete.service';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { AspNetAppRoleService } from '../Services/AspNetAppRoleService';
import { Profile } from '../models/Profile';
import { Kaizen } from '../kaizens/kaizen';
import { KaizenService } from '../kaizens/kaizen.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LoaderService } from '../loader/loader.service';
import { firstValueFrom, finalize } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';


@Component({
    selector: 'app-mykaizens',
    templateUrl: './my-kaizens.component.html',
    styleUrls: ['./my-kaizens.component.css'],
    standalone: false
})
export class MyKaizensComponent implements OnInit {
  displayedColumns: string[] = [
    'kaizenNumber',
    'company',
    'line',
    'shop',
    'name',
    'account',
    'fySavings',
    'updatedOn',
    'state',
    'action'
  ];
  //kaizens: Kaizen[] = [];
  dataSource = new MatTableDataSource<Kaizen>();
  showHidden: Boolean = false;
  showHiddenLabel: string = 'No';
  firstFormGroup!: UntypedFormGroup;

  selectedKaizen?: Kaizen;
  pageNumber = 1;
  pageSize = 25;
  totalItems = 0;

  searchText = '';
  @ViewChild(MatSort) sort!: MatSort;
  public profile!: Profile[];
  constructor(private kaizenService: KaizenService,
    private messageService: MessageService,
    private authService: MsalService,
    private dialogdeletekaizen: ConfirmDialogDeleteService,
    private router: Router,
    private appComponent: AppComponent,
    private formBuilder: UntypedFormBuilder,
    private aspNetAppRole: AspNetAppRoleService,
    private loaderService: LoaderService) { }

  header = 'Regional Kaizen system'
  ngOnInit(): void {

    const role = localStorage.getItem(`adroleNormalized`);
    if ((role != `Submitter`) && (role != `CMDApproverPlus`) && (role != `ISAdmin`) && (role != `SystemAdmin`)) {
      this.router.navigate([`./kaizens`]);
    }

    this.firstFormGroup = this.formBuilder.group({
      showHiddenKaizens: [''],
    });

    this.loadKaizens();
    this.aspNetAppRole.getAspNetUserRole(this.appComponent.ademail)
      .subscribe(
        data => {
          this.profile = data.data;
          // this.profileClaims = this.aspNetAppRole.setProfileClaim(this.profile[0].normalizedName);
        },
        error => console.log('error   ', error)
      )
  }
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }
  loadKaizens(): void {
    this.loaderService.isLoading.next(true);

    this.kaizenService
      .getKaizensByUserExcludeHiddenPaged(
        this.appComponent.ademail,
        this.pageNumber,
        this.pageSize
      )
      .pipe(
        finalize(() => this.loaderService.isLoading.next(false))
      )
      .subscribe({
        next: data => {
          this.dataSource.data = data.data;
          this.totalItems = data.totalCount;
        },
        error: error => console.log(error)
      });
  }
  onPageChange(event: PageEvent) {
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.loadKaizens();
  }
  DeleteKaizen(kaizenId: number) {
    this.dialogdeletekaizen.openDialog().afterClosed().subscribe(res => {
      console.log(res);
      if (res) {

        this.loaderService.isLoading.next(true);
        firstValueFrom(this.kaizenService.delKaizen(kaizenId)).then((data) => {
          this.router.navigate(['/mykaizens'])
            .then(() => {
              this.loaderService.isLoading.next(false);
              window.location.reload();
            });


        });
      }
    });
  }
  // getKaizens(): void { this.kaizenService.getKaizensByUserExcludeHidden(this.appComponent.ademail).subsscribe(data => this.dataSource.data= data.data, error => console.log(error), () => console.log(this.dataSource.data)); }
  // showHiddenKaizensChange(e: any) {
  //   this.showHidden = e.target.checked;
  //   if (this.showHidden) {
  //     this.showHiddenLabel = 'Yes';
  //     this.kaizenService.getKaizensByUser(this.appComponent.ademail).subsscribe(data => this.dataSource.data= data.data, error => console.log(error), () => console.log(this.dataSource.data));

  //   }
  //   else {
  //     this.showHiddenLabel = 'No';
  //     this.kaizenService.getKaizensByUserExcludeHidden(this.appComponent.ademail).subescribe(data => this.dataSource.data= data.data, error => console.log(error), () => console.log(this.dataSource.data));
  //   }

  // }
  getKaizens(): void {
    this.kaizenService.getKaizensByUserExcludeHidden(this.appComponent.ademail).subscribe({
      next: data => this.dataSource.data = data.data,
      error: error => console.log(error),
      complete: () => console.log(this.dataSource.data)
    });
  }

  showHiddenKaizensChange(e: any) {
    this.showHidden = e.target.checked;

    if (this.showHidden) {
      this.showHiddenLabel = 'Yes';
      this.kaizenService.getKaizensByUser(this.appComponent.ademail).subscribe({
        next: data => this.dataSource.data = data.data,
        error: error => console.log(error),
        complete: () => console.log(this.dataSource.data)
      });
    } else {
      this.showHiddenLabel = 'No';
      this.kaizenService.getKaizensByUserExcludeHidden(this.appComponent.ademail).subscribe({
        next: data => this.dataSource.data = data.data,
        error: error => console.log(error),
        complete: () => console.log(this.dataSource.data)
      });
    }
  }
  // OnSearch(criteria: string) {
  //   if (this.appComponent.adroleNormalized == 'ISAdmin' || this.appComponent.adroleNormalized == 'SystemAdmin') {
  //     // if the criteria is an empty string the just return all users with ot without hidden depending on slider position
  //     if (!criteria) {
  //       if (this.showHidden) {
  //         this.kaizenService.getKaizens().subscribse(data => this.dataSource.data= data.data, error => console.log(error), () => console.log(this.dataSource.data));

  //       }
  //       else {
  //         this.kaizenService.getKaizensExcludeHidden().subsscribe(data => this.dataSource.data= data.data, error => console.log(error), () => console.log(this.dataSource.data));
  //       }
  //     }
  //     else {
  //       this.kaizenService.searchKaizens(criteria, this.showHidden, '').subscribe(data => {
  //         this.dataSource.data= data.data;
  //       },
  //         error => console.log(error),
  //         () => console.log(this.dataSource.data));
  //     }
  //   }
  //   else {
  //     // if the criteria is an empty string the just return all users with ot without hidden depending on slider position
  //     if (!criteria) {
  //       if (this.showHidden) {
  //         this.kaizenService.getKaizensByUser(this.appComponent.ademail).subsscribe(data => this.dataSource.data= data.data, error => console.log(error), () => console.log(this.dataSource.data));

  //       }
  //       else {
  //         this.kaizenService.getKaizensByUserExcludeHidden(this.appComponent.ademail).subscsribe(data => this.dataSource.data= data.data, error => console.log(error), () => console.log(this.dataSource.data));
  //       }
  //     }
  //     else {
  //       this.kaizenService.searchKaizens(criteria, this.showHidden, this.appComponent.ademail).subscribe(data => {
  //         this.dataSource.data = data.data;
  //       },
  //         error => console.log(error),
  //         () => console.log(this.dataSource.data));
  //     }
  //   }

  // }
  OnSearch(criteria: string) {
    if (this.appComponent.adroleNormalized == 'ISAdmin' || this.appComponent.adroleNormalized == 'SystemAdmin') {
      // if the criteria is an empty string then just return all users with or without hidden depending on slider position
      if (!criteria) {
        if (this.showHidden) {
          this.kaizenService.getKaizens().subscribe({
            next: data => this.dataSource.data = data.data,
            error: error => console.log(error),
            complete: () => console.log(this.dataSource.data)
          });
        } else {
          this.kaizenService.getKaizensExcludeHidden().subscribe({
            next: data => this.dataSource.data = data.data,
            error: error => console.log(error),
            complete: () => console.log(this.dataSource.data)
          });
        }
      } else {
        this.kaizenService.searchKaizens(criteria, this.showHidden, '').subscribe({
          next: data => {
            this.dataSource.data = data.data;
          },
          error: error => console.log(error),
          complete: () => console.log(this.dataSource.data)
        });
      }
    } else {
      // if the criteria is an empty string then just return all users with or without hidden depending on slider position
      if (!criteria) {
        if (this.showHidden) {
          this.kaizenService.getKaizensByUser(this.appComponent.ademail).subscribe({
            next: data => this.dataSource.data = data.data,
            error: error => console.log(error),
            complete: () => console.log(this.dataSource.data)
          });
        } else {
          this.kaizenService.getKaizensByUserExcludeHidden(this.appComponent.ademail).subscribe({
            next: data => this.dataSource.data = data.data,
            error: error => console.log(error),
            complete: () => console.log(this.dataSource.data)
          });
        }
      } else {
        this.kaizenService.searchKaizens(criteria, this.showHidden, this.appComponent.ademail).subscribe({
          next: data => {
            this.dataSource.data = data.data;
          },
          error: error => console.log(error),
          complete: () => console.log(this.dataSource.data)
        });
      }
    }
  }
  shopSizer(shopname: string): string {
    let newshopname = '';
    if (shopname.length > 15) {
      newshopname = shopname.substring(0, 15) + '...';
    }
    else {
      newshopname = shopname;
    }
    return newshopname;
  }
}


